import Vue from 'vue'
import h5PublicApi from './public.js'

let content = `<div>Please note all information communicated in the Porsche Bytes are internal information, which shall be treated in confidence in accordance with the Dealer and Services Agreement. Any unauthorized disclosure or distribution, no matter by intention or negligence, may expose you and/or your entity to legal liabilities. By using the Porsche Bytes, you agree and undertake that you will observe the confidentiality obligations.</div>
				<div>敬请注意，本保时捷问卷调查沟通的所有信息均属于【内部】信息，应依据《经销商和服务协议》予以严格保密。任何未经授权的披露或传递，无论出于故意或过失，可能会使您和/或您所在的机构承担法律责任。使用本保时捷问卷调查表示您已同意并承诺遵守保密义务。</div>
				<div>Compliance with antitrust law is of crucial importance for Porsche. Porsche therefore expects of our dealers and their employees that they do not use any of Porsche's communication channels as forum for possible conduct in breach of antitrust law, just as Porsche itself would not use them in this way. In this connection, we tolerate neither anticompetitive agreements nor the exchange of competitively relevant information – irrespective of whether on the manufacturer, importer or retail level. We would like to ask you in your own interest to comply with these principles. Thank you very much.</div>
				<div>遵守反垄断法对保时捷来说至关重要。因此，保时捷期望保时捷的经销商伙伴及其员工不要将任何的保时捷沟通平台用作实施可能违反反垄断法的行为的平台，保时捷自己也将以身作则。就此而言，我们不会容忍反竞争协议的出现，亦不会容忍交流竞争相关信息的做法 – 无论是在制造商或进口商层面还是在零售层面。我们请您遵守这些原则以保护您自身利益。非常感谢！</div>
				<div>您当前的角色属于</div>
				<div class="special">
					【保时捷中心的那些事】 和 【培训中心的那些事】 为互动区，可供所有的用户提问与回答
				</div>
				<div style="color:#8abef3">
					百辞 拥有以下角色：<br/>
					游客：    浏览圈与互动区发帖回答权限<br/>
					经销商：拥有所有版块的提问权限与互动区回帖权限<br/>
					辅导员：拥有所有版块的提问权限，并能协助培训中心老师回答问题
				</div>`;

function agree(call){
	h5PublicApi.ajax('post','$/user/declaration',{}).then(r=>{
		Vue.prototype.$h5AgreeLegal = true
		call && call();
	}).catch(err => {
		console.error('err:' + err)
	})
}

export default {
	content: content,
	agree: agree,
}



// WEBPACK FOOTER //
// ./src/app/script/legal.js